import type { ObjectMapping } from '@shared/types/utils';

export const THING_TO_DO = 'thingToDo';
export const TRANSPORT = 'transport';
export const ADDRESS = 'address';
export const NEAREST_TRANSPORTATION = 'nearest_transportation';
export const NEAREST_POINT = 'nearest_point';
export const CITY_CENTER = 'city_center';
export const AIRPORT = 'airport';
export const MAP_VIEW = 'map_view';
export const MAP_VIEW_MARKER = 'map_view_marker';

export const MAPPING_MAP_CLICK_TYPE: ObjectMapping = {
  thingToDo: 'GOOD_POINT',
  transport: 'TRANSPORTATION',
  map_view: 'MAP_VIEW',
  map_view_marker: 'MAP_VIEW_MARKER',
  nearbyHotel: 'NEARBY_HOTEL',
  nearest_transportation: 'NEAREST_TRANSPORTATION',
  nearest_point: 'NEAREST_POINT',
  city_center: 'CITY_CENTER',
  airport: 'AIRPORT',
  address: 'ADDRESS',
};

export const MAX_POI_ITEM_SINGLE = 4;
